<template>
  <section
    class="container z-grid v-page-section-container-padding-wide-screens"
    :class="[{ 'pt-16': atPageTop && !backgroundMobile, 'sm:pt-16': atPageTop && backgroundMobile }, `t-${theme}`]"
  >
    <div
      class="relative z-10 z-grid__cols z-grid__content"
      :class="[backgroundColor, { 'pt-16 pb-4 sm:pb-0': atPageTop && backgroundMobile, 'rounded-b-3xl sm:rounded-3xl': !flatBottom, 'sm:rounded-t-3xl': flatBottom }]"
    >
      <div
        v-if="iconLeft && !backgroundMobile"
        class="absolute top-0 left-0 p-3 md:p-3 z-20 sm:bg-black rounded-br-2xl lg:rounded-br-3xl rounded-tl-2xl lg:rounded-tl-3xl flex items-center justify-center"
      >
        <AtomIcon :icon="iconLeft" classes="w-24 h-6 md:w-40 md:h-8 transition duration-300 fill-black fill-black sm:fill-white sm:stroke-white content-center" />
      </div>
      <div :class="[showTitlesOnLargeScreens ? 'block' : 'block sm:hidden', iconLeft ? 'mt-14' : '']">
        <AtomHeadingDetailPageMain
          v-if="title"
          :class="{ 'mb-4': subtitle || date, 'mb-6': !subtitle && !date }"
          :text-color="
            theme === 'light-blue'
              ? 'text-app-secondary-10-blue--royal-blue'
              : theme === 'red' || theme === 'dark-green' || theme === 'petrol'
                ? 'text-white sm:text-app-primary-1-red--fire-brick'
                : theme === 'violet'
                  ? 'text-white sm:text-app-secondary-7-violet--purple-heart'
                  : 'text-app-primary-1-red--fire-brick'
          "
          >{{ title }}</AtomHeadingDetailPageMain
        >

        <time v-if="date" :datetime="date.toISOString()" class="block mb-4">{{ $d(date, 'long-date') }}</time>
        <h2
          v-if="subtitle"
          class="text-xl sm:text-2xl leading-tight"
          :class="{
            'mb-6 lg:mb-8': introduction || description,
            'text-white  sm:text-current': theme === 'red' || theme === 'dark-green' || theme === 'petrol' || theme === 'violet',
          }"
        >
          {{ subtitle }}
        </h2>
        <slot name="chapeau" />
      </div>
      <div
        v-if="introduction"
        class="prose prose--app s-introduction"
        :class="[{ 'mb-6 lg:mb-8': description }, !mobileTheme ? 'prose--app--' + theme : 'prose--app--' + mobileTheme + ' sm:prose--app--' + theme]"
        v-html="introduction"
      />
      <div
        v-if="description"
        class="prose prose--app"
        :class="[!mobileTheme ? 'prose--app--' + theme : 'prose--app--' + mobileTheme + ' sm:prose--app--' + theme, proseClass]"
        v-html="description"
      />
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  atPageTop: { type: Boolean, required: false, default: false },
  iconLeft: { type: String, required: false, default: undefined },
  flatBottom: { type: Boolean, required: false, default: false },
  backgroundMobile: { type: Boolean, required: false, default: false },
  backgroundColor: { type: String, required: false, default: 'bg-white' },
  proseClass: { type: String, required: false, default: undefined },
  title: { type: String, required: false, default: undefined },
  subtitle: { type: String, required: false, default: undefined },
  showTitlesOnLargeScreens: { type: Boolean, required: false, default: true },
  introduction: { type: String, required: false, default: undefined },
  description: { type: String, required: false, default: undefined },
  date: { type: Date, required: false, default: undefined },
  theme: { type: String, required: false, default: undefined },
  mobileTheme: { type: String, required: false, default: undefined },
})
</script>

<style>
.t-light-blue h1,
.t-light-blue h2,
.t-light-blue h3 {
  @apply text-app-secondary-10-blue--royal-blue;
}
</style>
